import { h } from "omi";

import { IconProps } from "@/components";

export function DocumentPDFIcon({ width, height }: IconProps) {
  return (
    <svg fill="none" viewBox="0 0 40 40" width={width} height={height}>
      <path
        d="M7.75 4C7.75 2.20508 9.20508.75 11 .75h16c.1212 0 .2375.048159.3232.133885L38.1161 11.6768c.0857.0857.1339.202.1339.3232v24c0 1.7949-1.4551 3.25-3.25 3.25H11c-1.79493 0-3.25-1.4551-3.25-3.25V4Z"
        stroke="#D0D5DD"
        stroke-width="1.5"
      />
      <path d="M27 .5V8c0 2.2091 1.7909 4 4 4h7.5" stroke="#D0D5DD" stroke-width="1.5" />
      <rect x="1" y="18" width="26" height="16" rx="2" fill="#D92D20" />
      <path
        d="M4.8323 30v-7.2727h2.86932c.55161 0 1.02154.1053 1.4098.316.38825.2084.68418.4984.88778.8701.206.3693.309.7954.309 1.2784 0 .4829-.1042.9091-.31255 1.2784-.20833.3693-.51018.6569-.90554.8629-.39299.206-.86884.3089-1.42756.3089H5.83372v-1.2322h1.58025c.29593 0 .53978-.0509.73154-.1527.19413-.1042.33854-.2474.43324-.4297.09706-.1846.14559-.3965.14559-.6356 0-.2415-.04853-.4522-.14559-.6321-.0947-.1823-.23911-.3232-.43324-.4226-.19413-.1018-.44034-.1527-.73864-.1527H6.36994V30H4.8323Zm9.0527 0h-2.5781v-7.2727h2.5994c.7316 0 1.3613.1456 1.8892.4368.528.2888.934.7043 1.2181 1.2464.2864.5422.4297 1.1908.4297 1.946 0 .7576-.1433 1.4087-.4297 1.9532-.2841.5445-.6925.9623-1.2252 1.2535-.5303.2912-1.1647.4368-1.9034.4368Zm-1.0405-1.3175h.9766c.4546 0 .8369-.0805 1.147-.2414.3125-.1634.5469-.4155.7032-.7564.1586-.3433.2379-.786.2379-1.3282 0-.5374-.0793-.9765-.2379-1.3174-.1563-.3409-.3895-.5919-.6996-.7529-.3102-.161-.6925-.2415-1.147-.2415h-.9802v4.6378ZM18.5823 30v-7.2727h4.8153v1.2677h-3.2777v1.733h2.9581v1.2677h-2.9581V30h-1.5376Z"
        fill="#fff"
      />
    </svg>
  );
}
